import { ConnectedSelectPage } from "fleet/controller/device/connected-select-page";
import React from "react";
import { DELETE_DEVICES } from "redux-store/devices/actions";

function DeviceDeletePage() {
  const successMessage =
    "Your device deletion request has been received. " +
    "Your devices are queued for deletion and will be processed shortly.";

  return (
    <ConnectedSelectPage
      title="Delete"
      actionType={DELETE_DEVICES}
      successMessage={successMessage}
    />
  );
}

export { DeviceDeletePage };
